module.exports = __webpack_public_path__ + "img/MicrosoftDynamicsGP.bf9ef33e.png";